<template>
    <Bidder :is-test="isTestComputed"
            :is-active="isActiveComputed"
            :instance-id="instanceIdComputed"
            :show-no-groups-alert="showNoGroupsAlertComputed"
            :ad-unit="adUnit"
            :activeDisabled="activeDisabledComputed"
            @activeChanged="exportChange"
    ></Bidder>
</template>

<script>
import externalPropsParser from 'services/utils/externalPropsParser';
import Bidder from 'monetize/adUnitSettings/Bidder';
import eventBus from '@/mixins/eventBus';
import externalParsedProps from '@/mixins/externalParsedProps';

const parsedProps = ['isTest', 'isActive', 'instanceId', 'showNoGroupsAlert', 'activeDisabled'];

export default {
    name: 'AdUnitSettingsBidderEx',
    mixins: [
        eventBus('ad-unit-settings-bidder'),
        externalParsedProps(Bidder.props, parsedProps)
    ],
    props: externalPropsParser.setExternalProps(Bidder.props, parsedProps),
    methods: {
        exportChange(data) {
            this.$emit('activeChanged', data);
        }
    },
    components: { Bidder }
};
</script>
